import { render, staticRenderFns } from "./generalOnput.vue?vue&type=template&id=be0371d2&scoped=true&"
import script from "./generalOnput.vue?vue&type=script&lang=js&"
export * from "./generalOnput.vue?vue&type=script&lang=js&"
import style0 from "./generalOnput.vue?vue&type=style&index=0&id=be0371d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0371d2",
  null
  
)

export default component.exports